import { z } from 'zod';
/**
 * The two response shapes every endpoint returns, mirroring
 * `src/shared/http/envelope.ts`. Defined here so the API's routes and the admin
 * console validate against one definition rather than two that drift.
 */
export const errorDetailSchema = z.object({
    path: z.string(),
    message: z.string(),
});
/** `meta` is open by design — pagination lives here, and so does anything a route adds. */
export const responseMetaSchema = z.record(z.unknown());
export function successEnvelope(data) {
    return z.object({
        success: z.literal(true),
        data,
        meta: responseMetaSchema.optional(),
    });
}
/**
 * `code` is a plain string, not `apiErrorCodeSchema`.
 *
 * Parsing must not fail because a newer server introduced a code this build has
 * never heard of — the shape is the contract, the vocabulary is open. Callers
 * narrow with `isKnownErrorCode` when they need to branch.
 */
export const errorEnvelopeSchema = z.object({
    success: z.literal(false),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.array(errorDetailSchema).optional(),
        requestId: z.string(),
    }),
});
/** Either shape, discriminated on `success` so a parse failure means a real protocol violation. */
export function apiEnvelope(data) {
    return z.discriminatedUnion('success', [successEnvelope(data), errorEnvelopeSchema]);
}
//# sourceMappingURL=envelope.js.map